import React from 'react';
import PropTypes from 'prop-types';
import { Person } from '@mui/icons-material';
import { Card } from '@totalsoft/rocket-ui';
import PartnerFileBulkForm from './PartnerFileBulkForm';

function PartnerFileBulkFormCard({
  partnerFileBulkList,
  filters,
  onFilterChange,
  allPartnersSelected,
  anyPartnerSelected,
  onSelectAllPartners,
  pager,
  setPager,
  totalCount,
  setPartners,
  onCheckBoxChange,
  onAddBulkFile,
  saving
}) {
  return (
    <Card id={'partnerFileBulkFormCard'} icon={Person}>
      <PartnerFileBulkForm
        partnerFileBulkList={partnerFileBulkList}
        filters={filters}
        onFilterChange={onFilterChange}
        allPartnersSelected={allPartnersSelected}
        anyPartnerSelected={anyPartnerSelected}
        onSelectAllPartners={onSelectAllPartners}
        pager={pager}
        setPager={setPager}
        totalCount={totalCount}
        setPartners={setPartners}
        onCheckBoxChange={onCheckBoxChange}
        onAddBulkFile={onAddBulkFile}
        saving={saving}
      />
    </Card>
  );
}

PartnerFileBulkFormCard.propTypes = {
  partnerFileBulkList: PropTypes.array,
  filters: PropTypes.object.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  allPartnersSelected: PropTypes.bool.isRequired,
  anyPartnerSelected: PropTypes.bool.isRequired,
  onSelectAllPartners: PropTypes.func.isRequired,
  pager: PropTypes.number.isRequired,
  setPager: PropTypes.func.isRequired,
  totalCount: PropTypes.number.isRequired,
  setPartners: PropTypes.func.isRequired,
  onCheckBoxChange: PropTypes.func.isRequired,
  onAddBulkFile: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired
};

export default PartnerFileBulkFormCard;
